import _ from 'lodash';
import { SelectOption } from 'global';
import { EQUIPMENT_CLASS, EQUIPMENT_MAKE } from '@trnsact/business-criteria';
import { DiscountType, EquipmentCondition } from '@trnsact/trnsact-shared-types';

import { convertEnumValuesToSelectOptions } from '../../../utils/selectOptionsHelper';
import { PROSPECTIVE_INVENTORY_STATUS, SELECTABLE_INVENTORY_ITEM_STATUSES } from './inventoryStatus';

export const equipmentConditions: SelectOption[] = [
  { label: 'New', value: EquipmentCondition.New },
  { label: 'Used', value: EquipmentCondition.Used },
  { label: 'Reconditioned', value: EquipmentCondition.Reconditioned },
];

export const equipmentAttachmentTypes: SelectOption[] = [
  { label: 'Trailer', value: 'Trailer' },
  { label: 'Body', value: 'Body' },
  { label: 'Attachment', value: 'Attachment' },
];

export const discountTypes: SelectOption<DiscountType>[] = [
  { label: 'Flat', value: DiscountType.Flat },
  { label: 'Percentage', value: DiscountType.Percent },
];

export const makeOptions = convertEnumValuesToSelectOptions(EQUIPMENT_MAKE);

export const classOptions = convertEnumValuesToSelectOptions(EQUIPMENT_CLASS);

export const inventoryItemStatuses: SelectOption[] = SELECTABLE_INVENTORY_ITEM_STATUSES.map(status => ({
  label: status,
  value: status,
}));

// Shown only while editing a Prospective unit, so the select can display its current status until it is converted.
export const prospectiveInventoryItemStatusOption: SelectOption = {
  label: PROSPECTIVE_INVENTORY_STATUS,
  value: PROSPECTIVE_INVENTORY_STATUS,
};

export const equipmentYears = _.range(1990, new Date().getFullYear() + 3)
  .reverse()
  .map(value => ({
    label: value.toString(),
    value: value.toString(),
  }));
